import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
/** 
 * A React Card Component
 * @constructor
 * @param {string} [id] - Container dom element #id
 * @param {string} [className] - Container dom element .class
 * @param {string} title - Card head title
 * @param {string|number|dom} children - It's the card content
 * @param {boolean} enableFullScreen - Is enable full screen function
 * 
*/

var Card = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      openSideMenu = _useSelector.app.openSideMenu;

  var id = props.id,
      className = props.className,
      title = props.title,
      content = props.content,
      enableFullScreen = props.enableFullScreen,
      children = props.children,
      onFullScreenEvent = props.onFullScreenEvent;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      fullScreen = _useState2[0],
      setFullScreen = _useState2[1];

  var handleFullScreen = function handleFullScreen() {
    setFullScreen(!fullScreen);
    if (onFullScreenEvent) onFullScreenEvent();
  };

  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, {
      'fullScreen': fullScreen,
      'closeSideMenu': !openSideMenu
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-title"
  }, title), enableFullScreen && /*#__PURE__*/React.createElement("i", {
    className: cx('fas', fullScreen ? 'fa-compress-alt' : 'fa-expand-alt', 'fullScreen-icon'),
    onClick: handleFullScreen
  })), /*#__PURE__*/React.createElement("div", {
    className: "card-content"
  }, /*#__PURE__*/React.cloneElement(children, {
    isFullScreen: fullScreen
  })));
});
Card.defaultProps = {
  id: 'g-information-card',
  className: 'info-card',
  title: 'card-title',
  enableFullScreen: false
};
Card.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  enableFullScreen: PropTypes.bool
};
export default Card;